<template>
    <div class="alert alert-warning-light d-flex" role="alert" v-if="alertText">
        <img src="/themes/custom/ef2_custom/images/icons/info.svg" alt="Warning icon">
        {{ alertText }}
    </div>
</template>

<script>
export default {
    name: "Alert",
    props: {
        alertText: {
            type: String,
            required: true,
        }
    }
}
</script>

<style scoped>
.alert {
    line-height: 1;
    padding: 1rem;
}
.alert img {
    width: 1rem;
    height: 1rem;
    vertical-align: text-bottom;
    margin-right: 0.5rem;
}
</style>
